import { useCurrentBrand } from '@hooks';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { insuranceActions } from '../../../redux/slices/insurance';
import { env } from '../../../utils/functions';
import { InsuranceSettings } from '../core/types/InsuranceSettings';
import { getInsuranceParams } from '../getInsuranceParams';

export const useRIA = () => {
  const configContent = useSelector((state: any) => state.config);
  const insuranceEnabled = useSelector(
    (state: any) => state.insurance?.insuranceEnabled
  );
  const RIAConfigBaseUrl =
    'https://assets.lenscrafters.com/extra/image/rxc/ria/settings.json';
  const ecomInsuranceFunction = useSelector(
    (state: any) => state?.config?.insuranceModule?.getInsuranceSettings
  );

  const currentBrand = useCurrentBrand();
  const dispatch = useDispatch();

  const [RIAParams, setRIAParams] = useState<InsuranceSettings | null>(null);

  useEffect(() => {
    if (currentBrand && RIAConfigBaseUrl) {
      if (process.env.DEV) return;
      let brand = currentBrand === 'default' ? 'lenscrafters' : currentBrand;
      const environment = env(); //process.env.REACT_APP_ENVIRONMENT_URL;
      const ecomInsurance = ecomInsuranceFunction?.() || {};
      axios
        .get(RIAConfigBaseUrl)
        .then((res) => {
          try {
            const RIAParams = getInsuranceParams(
              res.data,
              ecomInsurance,
              brand,
              environment
            );
            setRIAParams(RIAParams);
            dispatch(
              insuranceActions.setPricingMethodConfig(RIAParams?.method)
            );
            window.rxcBrain.discountMethod = RIAParams?.method;
          } catch (error) {
            throw error;
          }
        })
        .catch((err) => {
          console.error(err);
          console.error(
            'Unable to retreive RIA configuration at url: ' + RIAConfigBaseUrl
          );
          try {
            //@ts-ignore
            window.tealium_data2track.push({
              id: 'Error',
              Error_Code: 'RX Configurator: Loading error',
              Error_Details: err,
              Error_Source: 'Client',
            });
          } catch (error) {
            console.error(
              'Error during tealium_data2track push. Check if tealium_data2track exists in the window.'
            );
          }
          if (!configContent.insuranceModule?.isLogged()) {
            dispatch(insuranceActions.setInsuranceEnabled(false));
          } else {
            configContent.insuranceModule.removeInsuranceBenefits() ?? null;
            dispatch(insuranceActions.setInsuranceEnabled(false));
          }
        });
    }
  }, [RIAConfigBaseUrl, currentBrand, insuranceEnabled]);
};
